// ui
import { Box, Alert } from "@mui/material";
import PersonOffIcon from "@mui/icons-material/PersonOff";

// ★cmd-po_1139: PoModalShell + PoButton で catalog 外殻を導入
import { PoModalShell } from "../common/PoModalShell";
import { PoButton } from "../common/PoButton";

interface PersonDataDeleteModalProps {
  onModal: boolean;
  swCloseModal: () => void;
  deletePersonDataInf: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  };
  setDeletePersonDataInf: (value: {
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }) => void;
  deletePersonData: () => void;
}

export function PersonDataDeleteModal(props: PersonDataDeleteModalProps) {
  const {
    onModal,
    swCloseModal,
    deletePersonDataInf,
    setDeletePersonDataInf,
    deletePersonData,
  } = props;

  const footer =
    deletePersonDataInf.status === "open" ? (
      <>
        <PoButton
          variant="secondary"
          data-testid="person-data-delete-close-button"
          onClick={swCloseModal}
        >
          閉じる
        </PoButton>
        <PoButton
          variant="primary"
          data-testid="person-data-delete-execute-button"
          onClick={deletePersonData}
        >
          個人情報削除
          <PersonOffIcon fontSize="small" />
        </PoButton>
      </>
    ) : deletePersonDataInf.status === "success" ? (
      <PoButton
        variant="secondary"
        data-testid="person-data-delete-success-close-button"
        onClick={swCloseModal}
      >
        閉じる
      </PoButton>
    ) : deletePersonDataInf.status === "failed" ? (
      <PoButton
        variant="secondary"
        data-testid="person-data-delete-retry-button"
        onClick={() =>
          setDeletePersonDataInf({
            ...deletePersonDataInf,
            status: "open",
            message: "",
          })
        }
      >
        戻る
      </PoButton>
    ) : null;

  return (
    <PoModalShell
      open={onModal}
      title="個人情報削除"
      onClose={swCloseModal}
      testidPrefix="person-data-delete"
      footer={footer}
    >
      {deletePersonDataInf.status === "open" ? (
        <Alert
          severity="error"
          sx={{
            bgcolor: "var(--sem-error-bg, #f6d5d1)",
            color: "var(--sem-error, #a53229)",
            fontSize: 12,
            borderRadius: "var(--radius-md, 10px)",
            p: "var(--sp-3, 12px) var(--sp-4, 16px)",
            "& .MuiAlert-icon": { color: "var(--sem-error, #a53229)" },
          }}
        >
          個人情報削除後、データは復元できません。
        </Alert>
      ) : deletePersonDataInf.status === "success" ? (
        <Box className="result-state -success" data-testid="result-state-success">
          <span className="rs-title">個人情報の削除に成功しました。</span>
        </Box>
      ) : deletePersonDataInf.status === "failed" ? (
        <Box className="result-state -failed" data-testid="result-state-failed">
          <span className="rs-title">{deletePersonDataInf.message}</span>
        </Box>
      ) : null}
    </PoModalShell>
  );
}
